import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./Component/Main";
import Login from "./Component/common/Login";
import ApplyAccountPage from "./Component/ApplyAccountPage";
import PlaceholderPage from "./Component/common/PlaceholderPage";
import MyAccount from "./Component/MyAccount";
import StoreDetail from "./Component/StoreDetail";
import StoreManage from "./Component/StoreManage";
import AccountPerson from "./Component/AccountPerson";
import InComingOrders from "./Component/InComingOrders";
import MessageList from "./Component/MessageList";
import UserMsg from "./Component/UserMsg";

function App() {
  return (
    <Router>
      <Routes>
        {/* 登录页面路由 */}
        <Route path="/" element={<Login />} />
        {/* 用户主页 */}
        <Route path="/userAccount" element={<Main />} />
        {/* 全球收款 */}
        <Route path="/apply-account" element={<ApplyAccountPage />} />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/store-detail/:id" element={<StoreDetail />} />
        <Route path="/store-management" element={<StoreManage />} />
        <Route path="/account-holder" element={<AccountPerson />} />
        {/* 全球付款 */}
        <Route path="/payment" element={<PlaceholderPage title="全球付款" />} />
        {/* 交易管理 */}
        <Route path="/incoming-orders" element={<InComingOrders />} />
        <Route
          path="/payment-orders"
          element={<PlaceholderPage title="付款订单" />}
        />
        <Route
          path="/turnover-management"
          element={<PlaceholderPage title="转账管理" />}
        />
        <Route
          path="/fund-planning"
          element={<PlaceholderPage title="资金划拨" />}
        />
        <Route
          path="/receipt-statement"
          element={<PlaceholderPage title="收支明细" />}
        />
        {/* 其他功能 */}
        <Route
          path="/exchange"
          element={<PlaceholderPage title="货币兑换" />}
        />
        <Route
          path="/domestic"
          element={<PlaceholderPage title="付款至境内" />}
        />
        <Route
          path="/ecard"
          element={<PlaceholderPage title="E付卡(虚拟卡)" />}
        />
        <Route path="/settings" element={<PlaceholderPage title="设置" />} />
        <Route path="/message-subscription" element={<MessageList />} />
        <Route
          path="/store-entity-management"
          element={<PlaceholderPage title="店铺主体管理" />}
        />
        <Route
          path="/agreement-management"
          element={<PlaceholderPage title="协议管理" />}
        />
        <Route
          path="/security-settings"
          element={<PlaceholderPage title="安全设置" />}
        />
        <Route
          path="/user-center"
          element={<PlaceholderPage title="安全设置" />}
        />
        <Route
          path="/real-name-auth"
          element={<PlaceholderPage title="实名认证" />}
        />
        <Route
          path="/account-settings"
          element={<PlaceholderPage title="账号设置" />}
        />
        <Route
          path="/store-entity-management"
          element={<PlaceholderPage title="店铺主体管理" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
